import AppNavItem from './AppNavItem';
import { IconCreditCard, IconDashboard, IconPlan, IconReport, IconGear } from './Icons';
import { useApplications } from '../contexts/Applications';

export default function AppNav({
  currentAppId,
  hasBilling,
}: {
  currentAppId: string;
  hasBilling: boolean;
}) {
  const { manageApplicationBilling } = useApplications();

  return (
    <div className="inline-flex items-center mb-5 text-white">
      <AppNavItem appId={currentAppId} menuItem="dashboard">
        <IconDashboard className="inline w-5 h-5 mr-2" />
        Dashboard
      </AppNavItem>
      <AppNavItem appId={currentAppId} menuItem="reports">
        <IconReport className="inline w-5 h-5 mr-2" />
        Reports
      </AppNavItem>
      {hasBilling && (
        <AppNavItem
          appId={currentAppId}
          menuItem="billing"
          onClick={async () => manageApplicationBilling(currentAppId)}
        >
          <IconCreditCard className="inline w-5 h-5 mr-2" />
          Billing
        </AppNavItem>
      )}
      <AppNavItem appId={currentAppId} menuItem="plan">
        <IconPlan className="inline w-5 h-5 mr-2" />
        Plan
      </AppNavItem>
      <AppNavItem appId={currentAppId} menuItem="settings">
        <IconGear className="inline w-5 h-5 mr-2" />
        Settings
      </AppNavItem>
    </div>
  );
}
